<template>
    <v-lazy transition="fab-transition">
        <v-card class="video-card" elevation="0">

        <div class="responsive-youtube">
            <iframe loading="lazy" :src="video"
                    :title="title"
                    frameborder="0"
                    allow=""
                    allowfullscreen></iframe>
        </div>
            <v-card-title class="video-title">{{ title }}</v-card-title>
            <v-card-text v-if="description" class="video-description">{{ description }}</v-card-text>
        </v-card>
    </v-lazy>
</template>

<script>
    export default {
        name: "YoutubeVid",
        props: {
            title: String,
            description: String,
            video: String
        }
    }
</script>

<style scoped>
    .responsive-youtube {
        background: #24123f;
        padding-top: 56.25%;
        overflow: hidden;
        position: relative;
        width: 100%;
    }

    .responsive-youtube::after {
        display: none;
    }

    .responsive-youtube iframe,
    .responsive-youtube object,
    .responsive-youtube embed {
        position: absolute;
        border: 0;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }

    .video-card { border: 1px solid #e9e3f1; border-radius: 16px; height: 100%; overflow: hidden; transition: box-shadow .2s ease, transform .2s ease; }
    .video-card:hover { box-shadow: 0 16px 32px rgba(50, 20, 77, .12) !important; transform: translateY(-4px); }
    .video-title { color: #24123f; font-size: 1rem; font-weight: 800; line-height: 1.3; padding: 20px 20px 8px; }
    .video-description { color: #696276; font-size: .88rem; line-height: 1.55; padding: 0 20px 20px; }
</style>
